import { Component } from '@angular/core';
import { Input } from '@angular/core';

@Component({
  selector: 'app-images',
  templateUrl: './images.component.html',
  styleUrls: ['./images.component.scss'],
})
export class ImagesComponent {
  @Input() src: string | null | undefined = null;
  @Input() alt = 'TSOLife';
  @Input() unsplashDefinition: {
    user: { name: string; links: { html: string } };
  } | null = null;
  @Input() class = '';
  @Input() style = '';
  private default =
    'https://dummyimage.com/200/ebebeb/bdbdbd.jpg?text=Unavailable';

  error(): void {
    this.src = this.default;
  }
}
